<template>
  <vonap-promised :promise="promise">
    <vonap-fullscreen-dialog :title="titleMessage" @save="formSubmit" @close="close">
      <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="formSubmit">
        <v-tabs>
          <v-tab>Info</v-tab>
          <v-tab-item>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-sm class="py-2">
                  <v-layout row wrap>
                    <v-flex md6 lg3>
                      <v-layout align-space-around justify-start column>
                        <v-flex>
                          <v-text-field
                            v-model="userModel.email"
                            type="email"
                            label="Email *"
                            required
                            :rules="[v => !!v || 'Email is required']"
                          ></v-text-field>
                        </v-flex>
                        <v-flex>
                          <v-text-field
                            v-model="userModel.firstName"
                            label="First Name"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex>
                          <v-text-field
                            v-model="userModel.lastName"
                            label="Last Name"
                          ></v-text-field>
                        </v-flex>
                        <v-flex>
                          <v-text-field
                            v-model="userModel.phoneNumber"
                            label="Phone Number"
                          ></v-text-field>
                        </v-flex>
                        <v-flex>
                          <v-select
                            :items="roles"
                            label="Role"
                            v-model="userModel.roleId"
                            item-text="roleName"
                            item-value="roleId"
                            required
                            :rules="[v => !!v || 'Role is required']"
                          ></v-select>
                        </v-flex>
                        <v-flex>
                          <v-switch
                            :label="
                              `Active: ${
                                userModel.isActive ? userModel.isActive.toString() : 'false'
                              }`
                            "
                            v-model="userModel.isActive"
                          ></v-switch>
                        </v-flex>

                        <v-flex>
                          <v-text-field
                            type="password"
                            :label="passwordLabel"
                            v-model="userModel.password"
                            :required="isNew"
                            :rules="
                              !isNew ? [] : [v => !!v || 'Password is required for new users']
                            "
                          ></v-text-field>
                        </v-flex>
                        <v-flex>
                          <v-text-field
                            type="password"
                            :label="confirmPasswordLabel"
                            v-model="userModel.confirmPassword"
                            :required="!passwordIsNullOrEmpty"
                            :rules="[
                              v =>
                                v == userModel.password ||
                                'The password confirmation does not match.',
                            ]"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex md6 lg3>
                      <v-layout align-space-around justify-start column>
                        <v-flex>
                          <vonap-switch-list
                            :data-source="markets"
                            flexSize="xs12"
                            hideSearch
                            :useVCard="false"
                            v-model="selectedMarkets"
                            data-value-field="marketId"
                            data-text-field="market"
                            data-primitive-value
                            select-all-label="Select all markets"
                          />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab>Client</v-tab>
          <v-tab-item>
            <v-container fluid grid-list-sm class="py-2">
              <v-layout row wrap>
                <v-flex lg3>
                  <v-select
                    :items="selecteClientDataItems"
                    label="Default Client"
                    v-model="userModel.defaultClientId"
                    item-text="clientName"
                    item-value="clientId"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-container>

            <vonap-switch-list
              :data-source="clients"
              v-model="selectedClients"
              data-value-field="clientId"
              data-text-field="clientName"
              data-primitive-value
              select-all-label="Select all clients"
            />
          </v-tab-item>
          <v-tab>Division Assignation</v-tab>
          <v-tab-item>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-xl>
                  <user-division-form
                    v-model="selectedDivisions"
                    :clients="selecteClientDataItems"
                    :divisions="selecteDivisionDataItems"
                  >
                  </user-division-form>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-form>
    </vonap-fullscreen-dialog>
  </vonap-promised>
</template>
<script>
import axios from 'axios'
import {mapGetters} from 'vuex'
import notification from '@/helpers/notification'
import UserDivisionForm from '@/components/UserManager/UserDivisionForm'
import VonapFullscreenDialog from '@/components/VonapFullscreenDialog'
import VonapSwitchList from '@/components/VonapSwitchList'
import VonapPromised from '@/components/VonapPromised'

export default {
  name: 'UserManagerTemplate',
  props: {
    userId: {type: Number, default: null},
    modalVisible: {type: Boolean, default: false},
    isDialog: {type: Boolean, default: true},
  },
  data() {
    return {
      valid: false,
      userModel: {},
      roles: [],
      markets: [],
      clients: [],
      divisions: [],
      selectedClients: [],
      selectedMarkets: [],
      selectedDivisions: [],
      clientDataSource: new kendo.data.DataSource({
        data: [],
        schema: {
          model: {
            id: 'clientId',
            fields: {
              clientId: {type: 'number'},
              clientName: {type: 'string'},
            },
          },
        },
      }),
    }
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    titleMessage: function() {
      return !this.userModel || !this.userModel.userName
        ? 'Create new user'
        : 'Edit user ' + this.userModel.userName
    },
    isNew: function() {
      return this.userId == 0
    },
    selecteClientDataItems() {
      return this.clients.filter(c => this.selectedClients.includes(c.clientId))
    },
    selecteDivisionDataItems() {
      return this.divisions.filter(c => this.selectedClients.includes(c.clientId))
    },
    passwordIsNullOrEmpty() {
      return !this.userModel.password || this.userModel.password.length === 0
    },
    passwordLabel() {
      return this.isNew ? 'Password *' : 'Password'
    },
    confirmPasswordLabel() {
      return this.isNew ? 'Confirm Password *' : 'Confirm Password'
    },
    promise() {
      return this.getFormData()
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    save() {
      this.getUserData()
      this.$emit('save')
    },
    async getFormData() {
      const {data} = await axios.get('/api/accounts/getModalData')
      this.markets = data.markets
      this.clients = data.clients
      this.divisions = data.divisions
      this.clientDataSource.data(this.clients)
      this.roles = data.roles

      if (this.userId > 0) {
        this.getUserData()
      } else {
        this.selectedClients = [+this.clientId]
        this.userModel.defaultClientId = +this.clientId
        this.userModel.isActive = true
      }
    },
    getUserData: async function() {
      const req = await axios
        .get('/api/accounts/getUser', {
          params: {
            userId: this.userId,
            t: new Date().getTime(),
          },
        })
        .catch(() => notification('Error getting user information', 'error'))
      let model = req.data[0]
      this.userModel = model
      this.selectedClients = model.clients.map(item => item.clientId)
      this.selectedDivisions = model.divisions.map(item => item.divisionId)
      this.selectedMarkets = model.markets.map(item => item.marketId)
    },
    async formSubmit() {
      if (!this.$refs.form.validate()) return

      this.userModel.clients = this.selectedClients.map(item => ({clientId: item}))
      this.userModel.divisions = this.selectedDivisions.map(item => ({divisionId: item}))
      this.userModel.markets = this.selectedMarkets.map(item => ({marketId: item}))

      if (this.isNew) {
        axios
          .post('/api/accounts/createUser', this.userModel)
          .then(response => {
            if (response.data == 'Ok') this.save()
          })
          .catch(() => notification('Some error', 'error'))
      } else {
        axios.post('/api/accounts/updateUser', this.userModel).then(response => {
          if (response.data == 'Ok') this.save()
          this.$store.dispatch('authentication/getNewAccessToken')
        })
      }
    },
  },
  components: {
    UserDivisionForm,
    VonapFullscreenDialog,
    VonapSwitchList,
    VonapPromised,
  },
}
</script>
